export const hallConstraints = {
  name: {
    minLength: 1,
    maxLength: 128,
  },
  description: {
    minLength: 0,
    maxLength: 255,
  },
  link: {
    minLength: 5,
    maxLength: 32,
  },
}

export const webliteOfficialChannelRoomId =
  '8b578541-9074-41c1-b47d-bbb116d8d0a6'

export const TEACHER_PLAYGROUND_CHANNEL_TAG = 'teacher-playground'

export const COURSE_VITRINE_TAG = 'course_vitrine_integrated'
export const PREMIUM_PLAN_TAG = 'premium_plan'
export const ISSUE_TAG = 'issue'
export const VOD_ACTIVATED_TAG = 'vod_activated'
export const MOOKEB_TAG = 'mookeb'
export const HIDE_MEMBER_COUNT_TAG = 'hide_member_count'
export const DISABLE_WATERMARK_TAG = 'disable_watermark'
